<markdown
  [src]="'https://raw.githubusercontent.com/ZsZs/processpuzzle/refs/heads/develop/libs/js-shared/test-util/README.md'"
  (load)="onLoad($event)"
  (error)="onError($event)">
</markdown>
